import { render } from "./NotificationFolderListview.vue?vue&type=template&id=14f87208&scoped=true&ts=true"
import script from "./NotificationFolderListview.vue?vue&type=script&lang=ts"
export * from "./NotificationFolderListview.vue?vue&type=script&lang=ts"

import "./NotificationFolderListview.vue?vue&type=style&index=0&id=14f87208&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f87208"]])

export default __exports__